import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { userAPI } from "../../api/apiClient";
import useApi from "../CustomHooks/useApi";
import { useToast } from "../../Contexts/ToastContext";
import Loading from "../../Loading";
import "../../css/Users/UsersManager.css";
import UserRoleEnum from "../../Enums/UserRoleEnum";
import { UserRoleFriendlyNames } from "../../Enums/UserRoleEnum";


const AddUserPopup = ({ onClose, onUserAdded }) => {
  const { callApi: createUserApi, isLoading: isCreating } = useApi();
  const { showToast, clearToast } = useToast();

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [error, setError] = useState("");

  const rolesList = Object.entries(UserRoleFriendlyNames)
  .filter(([role]) => Number(role) !== UserRoleEnum.ADMIN)
  .map(([role, label]) => ({ role: Number(role), label }))
  .sort((a, b) => a.label.localeCompare(b.label));

  const validateEmail = (email) => {
    return email.endsWith("@teczowadruzyna.org");
  };

  const handleRoleToggle = (role) => {
    setSelectedRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      setError("E-mail musi być w domenie @teczowadruzyna.org.");
      return;
    }
    if (!name.trim()) {
      setError("Preferowane imię i nazwisko są wymagane.");
      return;
    }
    if (selectedRoles.length === 0) {
      setError("Wybierz przynajmniej jedną rolę.");
      return;
    }

    setError("");
    onClose();
    showToast("Dodawanie użytkownix...", "processing");

    await createUserApi(
      () => userAPI.addUser({ email, name, roles: selectedRoles }),
      async () => {
        showToast("Użytkownix zostałx dodanx.", "success");
        await onUserAdded();
        onClose();
      },
      async () => {
        clearToast();
      }
    );
  };

  return (
    <div className="usersmanager-popup-overlay">
      <div className="usersmanager-popup fade-in">
        <div className="usersmanager-popup-header">
          <h3>Dodaj użytkownix</h3>
          <FaTimes className="usersmanager-popup-close" onClick={onClose} />
        </div>

        {isCreating ? (
          <Loading text="Dodawanie użytkownika..." />
        ) : (
          <>
            <div className="usersmanager-popup-body">
              <label>Email:</label>
              <input
                type="email"
                value={email}
                placeholder="email@teczowadruzyna.org"
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>Preferowane imię i nazwisko:</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label>Role:</label>
              <div className="usersmanager-popup-roles">
                {rolesList.map((r) => (
                  <div
                    key={r.role}
                    className={`usersmanager-popup-role ${selectedRoles.includes(r.role) ? "selected" : ""}`}
                    onClick={() => handleRoleToggle(r.role)}
                  >
                    {r.label}
                  </div>
                ))}
              </div>
              {error && <div className="usersmanager-error-message">{error}</div>}
            </div>

            <div className="usersmanager-popup-footer">
              <button className="usersmanager-submit-button" onClick={handleSubmit}>
                Dodaj
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddUserPopup;
